export default "__VITE_ASSET__DpLn0L7i__"